import {
  ADD_TO_BENEFICIARIESV2_LIST,
  RECEIVED_BENEFICIARIES,
  RECEIVED_UPDATE_BENEFICIARIES,
  SET_FIELD,
  UPDATE_BENE_EDIT
} from 'state/beneficiaries/BeneficiaryActions';
import {cloneDeep} from "lodash";

export const newPrimaryBeneficiaryInitialState = {
  birthDate: '',
  businessEntityName: '',
  businessEntityNames: null,
  designationId: 0,
  distributionAmount: 0,
  firstName: '',
  lastName: '',
  middleName: '',
  nameSuffix: '- -',
  relationshipId: 0,
  taxId: '',
  typeId: 1
};

export const newSecondaryBeneficiaryInitialState = {
  birthDate: '',
  businessEntityName: '',
  businessEntityNames: null,
  designationId: 1,
  distributionAmount: 0,
  firstName: '',
  lastName: '',
  middleName: '',
  nameSuffix: '- -',
  relationshipId: 0,
  taxId: '',
  typeId: 1
};
export const beneficiaryFormObj = {
  beneficiariesV2List:[],
  beneficiaryFormData:{
  firstName: '',
  middleName: '',
  lastName: '',
  name: '',
  nameSuffix: '',
  relationshipId: 0,
  relationshipName: '',
  designationId: 0,
  distributionAmount: 0,
  taxId: '',
  typeId: 1,
  birthDate: '',
  businessEntityName: '',
  businessEntityNames: null,
  beneficiaryCategory:'Primary Beneficiary',
  beneficiaryType:'Individual'
}};
export const beneficiariesReducer = (state = [], action) => {
  if (action.type === RECEIVED_BENEFICIARIES) {
    return action.beneficiaries;
  }

  if (action.type === RECEIVED_UPDATE_BENEFICIARIES) {
    return state;
  }

  return state;
};

export const isEditingBeneficiariesReducer = (state, action) => {
  if (action.type === UPDATE_BENE_EDIT) {
    return action.value;
  }

  return state;
};
export const beneficiariesFormReducer = (state = beneficiaryFormObj, action) => {
  let newState;
  switch (action.type) {
    case SET_FIELD:
      newState = {
        ...state,
        beneficiaryFormData: {
          ...state.beneficiaryFormData,
          [action.payload.field]: action.payload.value,
        },
      };
      break;
      case ADD_TO_BENEFICIARIESV2_LIST:
      newState = {
        ...state,
        beneficiariesV2List: [...state.beneficiariesV2List, action.payload],
      };
      break;
    default:
      newState = state;
  }
  return newState;
};

const beneficiariesV2initialState = {
  managedBeneficiaries: [],
  previousManagedBeneficiaries:[]
};

export const managedBeneficiariesGroupV2Reducer = (state = beneficiariesV2initialState, action) => {
  switch (action.type) {
    case 'SET_MANAGE_BENEFICIARIES': {
      const payload=[...action.payload.primary, ...action.payload.secondary];
      return {
        ...state,
        managedBeneficiaries: payload,
        previousManagedBeneficiaries:payload
      };
    }
    case 'UPDATE_MANAGED_BENEFICIARY': {
      const { selectedBeneficiaryId, updatedBeneficiary } = action.payload;

      const updatedBeneficiaries = cloneDeep(state.managedBeneficiaries).map(beneficiary =>
          beneficiary._id === selectedBeneficiaryId
              ? { ...beneficiary, ...updatedBeneficiary }
              : beneficiary
      );

      return {
        ...state,
        managedBeneficiaries: updatedBeneficiaries
      };
    }
    case 'PUSH_NEW_BENEFICIARY': {
      const newBeneficiary = action.payload;
      const updatedManageBeneficiaries = cloneDeep(state.managedBeneficiaries);

      // Check if the new beneficiary has an _id, if not, generate one
      if (newBeneficiary._id === undefined || newBeneficiary._id === null) {
        const existingIds = updatedManageBeneficiaries.map(b => b._id);
        let newId = 0;
        while (existingIds.includes(newId)) {
          newId++;
        }
        newBeneficiary._id = newId;
      }

      updatedManageBeneficiaries.push(newBeneficiary);

      return {
        ...state,
        managedBeneficiaries: updatedManageBeneficiaries
      };
    }
    case 'RECEIVED_UPDATE_BENEFICIARIES': {
      return state;
    }
    default:
      return state;
  }
};
